import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'

import OrderAPI from '../../../api/orbitV1/OrderAPI'
import PageLayout from '../../../common/Layout/Page/PageLayout'
import { ColorBoxContent, ColorBoxHeader } from '../../../common/ui/colorBox'
import {
  OrderChangeState,
  OrderChangeStateActions
} from '../../../types/order.type'
import OrderDetails from '../SharedComponents/OrderDetails'

import SuggestedPairingsTable from './components/SuggestedPairingsTable'

function ProvisionOrderPage() {
  const { orderId } = useParams()
  const navigate = useNavigate()

  /**
   * Fetch from backend and store into state.
   * @type {[import('../../../types/order.type').OrderModel | null, *]}
   * */
  const [orderDetails, setOrderDetails] = useState(null)
  useEffect(() => {
    async function getOrderDetails() {
      try {
        const orderStatus = await OrderAPI.getOrderStatus(orderId)

        setOrderDetails(orderStatus.data)
      } catch (error) {
        toast.error(error.message)
      }
    }

    getOrderDetails()
  }, [orderId, setOrderDetails])

  // validate that order is in correct state
  const [isValidOrder, setIsValidOrder] = useState(false)
  useEffect(() => {
    if (!orderDetails) {
      return
    }

    if (
      orderDetails.status === OrderChangeState.PAYMENT_RECEIVED ||
      orderDetails.status === OrderChangeState.PREPARING
    ) {
      setIsValidOrder(true)
    }
  }, [orderDetails, setIsValidOrder])

  const confirmProvisioning = async (e) => {
    e.preventDefault()

    try {
      const orderStateUpdated = await OrderAPI.updateOrderState(orderId, {
        action: OrderChangeStateActions.OPS_DONE_PREP
      })

      if (orderStateUpdated) {
        toast.success(`Provisioning for order ${orderId} is done`)
        navigate('/hq/manage-orders', { replace: true })
      }
    } catch (error) {
      toast.error(`Failed to provision for order ${orderId}`)
    }
  }

  if (!orderDetails) {
    return <div>Loading.</div>
  }

  if (!isValidOrder) {
    return (
      <div>
        <ColorBoxHeader>Provision Order</ColorBoxHeader>
        <ColorBoxContent>
          <p>
            Cannot provision for Order <strong>#{orderId}</strong>.
          </p>
          <p>Order is not in the correct state</p>
        </ColorBoxContent>
      </div>
    )
  }

  return (
    <PageLayout header='Provision Order'>
      <ColorBoxContent style={{ marginTop: '1rem' }}>
        <div style={{ marginBottom: '1rem' }}>
          <strong>Currently provisioning for:</strong> <br />
          <br />
          Order Number: <strong>#{orderId}</strong>
          <br />
          Order Status: <strong>{orderDetails.status}</strong>
          <br />
          Details: <OrderDetails order={orderDetails} />
        </div>
      </ColorBoxContent>
      <ColorBoxContent style={{ marginTop: '1em' }}>
        <strong>Allocated Pairings: </strong> <br />
        <SuggestedPairingsTable
          order={orderDetails}
          onConfirm={confirmProvisioning}
        />
      </ColorBoxContent>
    </PageLayout>
  )
}

export default ProvisionOrderPage
